import { render } from "./NextButton.vue?vue&type=template&id=6a7b9576&scoped=true&ts=true"
import script from "./NextButton.vue?vue&type=script&lang=ts"
export * from "./NextButton.vue?vue&type=script&lang=ts"

import "./NextButton.vue?vue&type=style&index=0&id=6a7b9576&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7b9576"]])

export default __exports__